  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 991) {
      const toggles = document.querySelectorAll(".mobile-toggle");

      toggles.forEach(function (toggle) {
        toggle.addEventListener("click", function () {
          const content = this.nextElementSibling;
          const isOpen = content.classList.contains("open");

          // Toggle classes
          this.classList.toggle("active");
          content.classList.toggle("open");

          // Optional: reset max-height for animation
          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + "px";
          } else {
            content.style.maxHeight = null;
          }
        });
      });
    }
  });